export default "<h3>October 12, 2019</h3>\r\n<p>Update 1.33 fixes some minor bugs.</p>";